// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"_2vx4PF","property-tax-table-wrapper":"jmHJUs","property-tax-table":"z77ock","copy":"_2qyOIJ","caption":"_3qnTSy"};